<template lang="jade">
  .Carousel
    .Carousel__frame
      ul.Carousel__list(v-bind:class="{'Carousel__list--is-reversing': reverse, 'Carousel__list--is-set': rendered}"
                        v-el:carousel-items)
        li.Carousel__item(v-for="item in items"
                          v-bind:class="{'Carousel__item--is-ref': $index === 0}")
          component(":is"="item.type" ":fdata"="item.content")
    .Carousel__previous(v-show="items.length > 3"
                        @click="previous")
      i.fa.fa-chevron-left
    .Carousel__next(v-show="items.length > 3"
                    @click="next")
      i.fa.fa-chevron-right
    .Carousel__bullets
      .Carousel__bullet
</template>

<script>
import _ from 'lodash'
import Cards from '../cards'

export default {
  data () {
    return {
      uid: this.$parent.uid,
      items: [],
      reverse: false,
      rendered: false,
      cursor: 0
    }
  },
  props: {
    fdata: {
      type: Object,
      required: true
    }
  },
  created () {
    let table = _.head(this.fdata.content)
    let items = _.map(table.content, this.defType)
    this.$set('items', items)
    if (items.length > 3) {
      setInterval(() => { this.next() }, 5000)
    }
  },
  components: Cards,
  methods: {
    next () {
      this.$set('cursor', this.cursor < this.items.length ? (this.cursor + 1) : 0)
      this.$set('reverse', false)
      this.renderList()
    },
    previous () {
      this.$set('cursor', this.cursor < 0 ? this.items.length : (this.cursor - 1))
      this.$set('reverse', true)
      this.renderList()
    },
    setOrder () {
      let {children} = this.$els.carouselItems
      Array.from(children).forEach((el, idx) => {
        let offset = this.cursor - idx
        el.style['order'] = (offset <= 0) ? _.add(Math.abs(offset), 1) : (this.items.length + 1) - offset
      })
    },
    defType (x) {
      let type = _.head(x.currentFragmentId.split('.')).toLowerCase()
      return _.set(x, 'type', type)
    },
    renderList () {
      this.setOrder()
      this.$set('rendered', false)
      setTimeout(() => { this.$set('rendered', true) }, 50)
    }
  }
}
</script>



// WEBPACK FOOTER //
// carousel.vue?63263524